import { Preloader } from "shared/ui/Preloader";
import styles from "./LoadCard.module.scss";

import { CardBase } from "../../Card";

type LoadCardProps = {
  text: string;
};

export const LoadCard: RFC<LoadCardProps> = ({ text }) => {
  return (
    <CardBase>
      <CardBase.Row className={styles.loaderBox}>
        <Preloader className={styles.preloader} />
      </CardBase.Row>
      <CardBase.Row className={styles.titleBox}>
        <p className={styles.title}>{text}</p>
      </CardBase.Row>
    </CardBase>
  );
};
